import { render, staticRenderFns } from "./slot-widget.vue?vue&type=template&id=856e2df6&scoped=true&"
import script from "./slot-widget.vue?vue&type=script&lang=js&"
export * from "./slot-widget.vue?vue&type=script&lang=js&"
import style0 from "./slot-widget.vue?vue&type=style&index=0&id=856e2df6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856e2df6",
  null
  
)

export default component.exports